export default __webpack_public_path__ + "static/media/post-delegation.26b123e6.png";